<template>
  <TCheckbox
    :model-value="bulkEdit.isSelected(item.id).value"
    @update:model-value="
      (value) => (value ? bulkEdit.select(item.id) : bulkEdit.deselect(item.id))
    "
    @click.stop
  />
</template>
<script
  setup
  lang="ts"
  generic="T extends Record<string, unknown> & { id: string }"
>
import { injectOrFail } from '@teachino/shared-util';
import TCheckbox from '../TCheckbox.vue';
import { bulkEditInjectionKey, bulkEditItemInjectionKey } from './bulk-edit';

const bulkEdit = injectOrFail(
  bulkEditInjectionKey,
  'This component can only be used inside a BulkEditGroup',
);

const item = injectOrFail(
  bulkEditItemInjectionKey,
  'This component can only be used inside a BulkEditItem',
);
</script>
